import { render } from "./Itineraries.vue?vue&type=template&id=8051216e"
import script from "./Itineraries.vue?vue&type=script&lang=js"
export * from "./Itineraries.vue?vue&type=script&lang=js"

import "./Itineraries.vue?vue&type=style&index=0&id=8051216e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__